import React, { FC } from 'react';

import styles from './ToolBarIconButton.module.scss';

export interface IconButtonProps {
  icon: React.FC<{ className?: string }>;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  testId?: string;
}

export const ToolBarIconButton: FC<IconButtonProps> = (props) => {
  const Icon = props.icon;
  return (
    <a
      data-disabled={props.disabled}
      data-test-id={props.testId}
      onClick={props.onClick}
      className={styles.toolbarIconButton}
    >
      <Icon className={styles.icon} />
    </a>
  );
};
